cbp-multicol {
  display: block;

  & > * {
    max-width: 100%;
  }

  &[nobreak] > * {
    break-inside: avoid;
  }
}
